module.exports = __webpack_public_path__ + "img/vivabien.fdfdadac.png";